// import { Link } from 'react-router-dom'
import style from './style.module.css'
import Menu from './menu'
import { ReactComponent as InspireLogo } from 'assets/icon-inspire.svg'

const Header = ({ loggedIn = true }) => {
  
    return (
        <div className={style.header}>
          <div className={style.headerBrand}>
            <InspireLogo className={style.headerLogo} />
          </div>
          <div className={style.headerSpacer} />
          {loggedIn && <ul className={style.headerNav}>
            <li className={style.headerNavItem}>
              <Menu />
            </li>
          </ul>}
        </div>
    )

}

export default Header